module.exports = __webpack_public_path__ + "assets/373f9340b397b02140f2eda9addae466.mp3";